module.exports = __webpack_public_path__ + "img/aParty_110523_D.fbc1fffe.jpg";